import type { TFunction } from 'i18next';

import type { ProviderFieldSchema } from '@/domain/providerConfig';

import { defaultLabelKey } from './enumChoices';

export interface FieldTexts {
    label: string;
    /** What the fetch uses while the field is empty, as the page says it; null for none. */
    defaultText: string | null;
    placeholder: string | undefined;
}

/** A field's label, default and placeholder, a caller's own label and placeholder first. */
export function fieldTexts(
    field: ProviderFieldSchema,
    t: TFunction,
    label?: string,
    placeholder?: string
): FieldTexts {
    const defaultKey = defaultLabelKey(field);
    const defaultText = defaultKey === null ? field.defaultValue : t(defaultKey);
    return {
        label:
            label ??
            (field.subject === null
                ? t(field.labelKey)
                : t(field.labelKey, { subject: t(`providerConfig.subjects.${field.subject}`) })),
        defaultText,
        placeholder:
            placeholder ??
            (defaultText === null
                ? undefined
                : t('providerConfig.defaults.placeholder', { value: defaultText })),
    };
}
